const tenantId = process.env.REACT_APP_TENANT_ID || "";
const authorityBase = `https://login.microsoftonline.com/${tenantId}`;

const resolveClientId = (primary) =>
  primary ||
  process.env.REACT_APP_DEV_CLIENT_ID ||
  process.env.REACT_APP_QA_CLIENT_ID ||
  process.env.REACT_APP_PROD_CLIENT_ID ||
  "";

export const devCred = {
    clientId: process.env.REACT_APP_DEV_CLIENT_ID || "",
    authority: authorityBase,
    redirectUri: "/",
    postLogoutRedirectUri: "/",
    navigateToLoginRequestUrl: false,
     tokenEndpoint: `${authorityBase}/oauth2/v2.0/token`,
    authorizationEndpoint: `${authorityBase}/oauth2/v2.0/authorize`,
    cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
    
};

export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};

export const devApiRequest = {
  scopes: [`api://${resolveClientId(process.env.REACT_APP_DEV_CLIENT_ID)}/SupplyChainNerveCenter`],
};

export const qaApiRequest = {
  scopes: [`api://${resolveClientId(process.env.REACT_APP_QA_CLIENT_ID)}/SupplyChainNerveCenter`],
};

export const prodApiRequest = {
  scopes: [`api://${resolveClientId(process.env.REACT_APP_PROD_CLIENT_ID)}/SupplyChainNerveCenter`],
};

export const getApiRequest = () => {
  if (process.env.REACT_APP_ENV === "production") {
    return prodApiRequest;
  } else if (process.env.REACT_APP_ENV === "DEV") {
    return devApiRequest;
  }
  return qaApiRequest;
};

export const qaCred = {
    clientId: process.env.REACT_APP_QA_CLIENT_ID || "",
    authority: authorityBase,
    redirectUri: "/",
    postLogoutRedirectUri: "/",
    navigateToLoginRequestUrl: false,
    tokenEndpoint: `${authorityBase}/oauth2/v2.0/token`,
    authorizationEndpoint: `${authorityBase}/oauth2/v2.0/authorize`,
};


export const prodCred = {
    clientId: process.env.REACT_APP_PROD_CLIENT_ID || "",
    authority: authorityBase,
    redirectUri: "/",
    postLogoutRedirectUri: "/",
    navigateToLoginRequestUrl: false,
    tokenEndpoint: `${authorityBase}/oauth2/v2.0/token`,
    authorizationEndpoint: `${authorityBase}/oauth2/v2.0/authorize`,
};




